import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';

import { CreateAccountComponent } from './create-account/create-account.component';
import { LoginComponent } from './login/login.component';
import { EmailVerificationCtaComponent } from './email-verification-cta/email-verification-cta.component';
import { EmailVerificationCompleteComponent } from './email-verification-complete/email-verification-complete.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginSuccessfulComponent } from './login-successful/login-successful.component';
import { SignoutComponent } from './signout/signout.component';
import {CreateWithGoogleComponent} from "./create-with-google/create-with-google.component";
import {SignInWithGoogleComponent} from "./sign-in-with-google/sign-in-with-google.component";
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {progressBarInterceptor} from "./interceptors/progress-bar-request-interceptor.interceptor";
import {AngularFireModule} from "@angular/fire/compat";
import {environment} from "../../../../environments/environment";
import {AngularFireAuthModule} from "@angular/fire/compat/auth";
import {SignInWithAppleComponent} from "./sign-in-with-apple/sign-in-with-apple.component";
import {CreateWithAppleComponent} from "./create-with-apple/create-with-apple.component";

@NgModule({
  declarations: [
    AppComponent,
    CreateAccountComponent,
    LoginComponent,
    EmailVerificationCtaComponent,
    EmailVerificationCompleteComponent,
    VerifyEmailComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    LoginSuccessfulComponent,
    SignoutComponent,
    CreateWithGoogleComponent,
    CreateWithAppleComponent,
    SignInWithGoogleComponent,
    SignInWithAppleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    SharedModule,
    ...SharedModule.sharedRootModules(),
  ],
  providers: [
    provideHttpClient(
      withFetch(),
      withInterceptors([progressBarInterceptor])
    ),
    ...SharedModule.sharedProviders(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
